import { DEFAULT_WITHDRAW_SLIPPAGE } from "../constants";
import { fetchWithdrawAssets } from "./withdraw-assets";
async function getAssetSlippage(chainId, vaultAddress, tokenAddress, defaultSlippage = DEFAULT_WITHDRAW_SLIPPAGE) {
  try {
    const withdrawAssets = await fetchWithdrawAssets();
    if (!withdrawAssets) {
      console.log("No withdraw assets data found, using default slippage");
      return defaultSlippage;
    }
    if (!withdrawAssets[chainId.toString()]) {
      console.log(
        "No withdraw assets data found for chainId, using default slippage"
      );
      return defaultSlippage;
    }
    if (!withdrawAssets[chainId.toString()][vaultAddress.toLowerCase()]) {
      console.log(
        "No withdraw assets data found for vaultAddress, using default slippage"
      );
      return defaultSlippage;
    }
    if (!withdrawAssets[chainId.toString()][vaultAddress.toLowerCase()][tokenAddress.toLowerCase()]) {
      console.log(
        "No withdraw assets data found for tokenAddress, using default slippage"
      );
      return defaultSlippage;
    }
    return withdrawAssets[chainId.toString()][vaultAddress.toLowerCase()][tokenAddress.toLowerCase()];
  } catch (error) {
    console.error("Error getting asset slippage so that is bad:", error);
    throw error;
  }
}
export {
  getAssetSlippage
};
//# sourceMappingURL=solver-slippage.mjs.map